var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowright({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98027 6.9999C7.98027 7.25081 7.88447 7.50168 7.69327 7.69297L1.67362 13.7126C1.29069 14.0955 0.669847 14.0955 0.287077 13.7126C-0.0956924 13.3298 -0.0956924 12.7091 0.287077 12.3261L5.6136 6.9999L0.287263 1.67366C-0.0955064 1.29073 -0.0955064 0.670073 0.287263 0.287333C0.670033 -0.0957766 1.29088 -0.0957766 1.6738 0.287333L7.69346 6.30683C7.88469 6.49822 7.98027 6.74909 7.98027 6.9999Z",
    fill: "#1B9075"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowright);
export default __webpack_public_path__ + "static/media/arrowright.bc77fa4977c82aa829bea5f7473bdd3c.svg";
export { ForwardRef as ReactComponent };